import React, { Component } from 'react';
import { connect } from 'react-redux';

import ActionButton from 'components/buttons/action-button/ActionButton';

import * as AdminPanel from '../admin-panel';

import { addCollabarySupportToProfile } from '../../reducers/admin-collabary-support/AdminCollabarySupport';
import { hideConfirmModal, showConfirmModal } from 'redux-store/reducers/modal-reducer';

import { __t, applyTranslations } from 'utils/language';

import type { BrandProfile } from 'types';

applyTranslations(require('./brand-profile-admin-panel.i18n.json'));

type OwnProps = {
  profile: BrandProfile
};

type DispatchProps = {
  dispatchShowConfirmationModal: (
    params: {
      message: string,
      onConfirm: () => void,
      onCancel: () => void
    }
  ) => void,
  dispatchHideConfirmationModal: () => void,
  dispatchAddSupportToBrandProfile: (BrandProfile) => void
};

type Props = OwnProps & DispatchProps;

const MSG_KEY = 'profile_team_actions';

class BrandProfileTeamActions extends Component<Props> {
  handleAdd = () => {
    const {
      profile,
      dispatchShowConfirmationModal,
      dispatchHideConfirmationModal,
      dispatchAddSupportToBrandProfile
    } = this.props;

    dispatchShowConfirmationModal({
      message: __t(`${MSG_KEY}.invite_confirmation`),
      onConfirm: () => {
        dispatchHideConfirmationModal();
        dispatchAddSupportToBrandProfile(profile);
      },
      onCancel: () => dispatchHideConfirmationModal()
    });
  };

  render() {
    return (
      <AdminPanel.Block>
        <AdminPanel.BlockTitle
          title={__t(`${MSG_KEY}.title`)}
          tooltip={__t(`${MSG_KEY}.tooltip`)}
        />
        <ActionButton onClick={this.handleAdd}>
          {__t(`${MSG_KEY}.add_label`)}
        </ActionButton>
      </AdminPanel.Block>
    );
  }
}

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchShowConfirmationModal: (params) => dispatch(showConfirmModal(params)),
  dispatchHideConfirmationModal: () => dispatch(hideConfirmModal()),
  dispatchAddSupportToBrandProfile: (profile) => dispatch(addCollabarySupportToProfile(profile.id, 'brand'))
});

export default connect(undefined, mapDispatchToProps)(BrandProfileTeamActions);
